import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
} from "@coreui/react";

import "../../Table/Table.scss";
const EquipmentTab = ({ object }) => {
  const [constructionData, setConstructionData] = useState([]);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (object?.LDoc) {
      axios
        .get(`/api/ldoc/${object?.LDoc}/construction/`, {
          headers: {
            Authorization: `Bearer ${token}`, // Добавляем токен в заголовок
          },
        })
        .then((response) => {
          setConstructionData(response.data || []);
        })
        .catch((error) => {});
    }
  }, [object?.LDoc]);

  return (
    <div>
      {constructionData.length === 0 ? (
        <p>Информация о конструктивных решениях не найдена.</p>
      ) : (
        // Группируем данные по 'construction'
        Object.values(
          constructionData.reduce((acc, section) => {
            // Если раздел уже есть в аккумуляторе, добавляем новый элемент, иначе создаем новый раздел
            if (!acc[section.construction]) {
              acc[section.construction] = [];
            }
            acc[section.construction].push(section);
            return acc;
          }, {})
        ).map((group, idx) => (
          <div className="about-objects__wrapper" key={idx}>
            <h5 className="about-objects__title">{group[0].construction}</h5>{" "}
            {/* Показываем название раздела один раз */}
            <CTable className="about-objects__table">
              <CTableBody className="about-objects__body">
                {group.map((section, i) => (
                  <CTableRow key={i}>
                    <CTableDataCell>{section.subConstruction}</CTableDataCell>
                    <CTableDataCell>{section.description}</CTableDataCell>
                  </CTableRow>
                ))}
              </CTableBody>
            </CTable>
          </div>
        ))
      )}
    </div>
  );
};

export default EquipmentTab;
